import React from "react";
import BudgetVsActual from "@/components/BudgetVsActual";
import { Receipt } from "lucide-react";

export default function ExpenseBudget() {
  return (
    <BudgetVsActual
      endpoint="/finance/expense-budget-monthly"
      queryKey="expense-budget-monthly"
      title="Έξοδα — Προϋπολογισμός vs Πραγματικά"
      subtitle="Μηνιαίος προϋπολογισμός εξόδων ανά λογαριασμό και σύγκριση με τα πραγματικά (καθαρά ποσά, ημ/νία παραστατικού)."
      icon={Receipt}
      isCost={true}
    />
  );
}
